export default __webpack_public_path__ + "8f6e0c25bb3cca47258374bfb22fdbb2.svg";